import axios from "axios";
import instance,{BASE_URL} from "../../services/api";
import toast from 'react-hot-toast';

const HolidayViewController = () => {
   const getErrorMessage = (error) => {
  return (
    error.response?.data?.detail ||   // Django REST Framework style
    error.response?.data?.message ||  // custom backend message
    error.response?.data?.error ||    // another fallback
    error.message ||                  // Axios default
    "Something went wrong!"
  );
};
  const getEmployerHoliday = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(
        `${BASE_URL}company-holidays/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "GET_HOLIDAYS_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "GET_HOLIDAYS_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };

  const addEmployerHoliday = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.post(
        `${BASE_URL}company-holidays/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "ADD_HOLIDAY_SUCCESS", payload: data });
      dispatch(getEmployerHoliday());
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "ADD_HOLIDAY_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };

  return {
    getEmployerHoliday,
    addEmployerHoliday,
  };
};

export default HolidayViewController;
